<template>
  <v-row>
    <v-col cols="12" md="6" lg="4" v-for="page in pages" :key="page.to">
      <v-card :elevation="1" link :to="page.to">
        <v-card-item>
          <template v-slot:prepend>
            <v-icon :icon="page.icon" size="large" class="mr-2"></v-icon>
          </template>
          <v-card-title>{{ page.title }}</v-card-title>
          <v-card-subtitle>{{ page.subtitle }}</v-card-subtitle>
        </v-card-item>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      pages: [
        {
          title: 'price backfill',
          subtitle: 'fetch and backfill historical security prices',
          icon: 'mdi-database-arrow-down-outline',
          to: '/admin/price-backfill',
        },
        {
          title: 'dividend backfill',
          subtitle: 'fetch and backfill historical distributions',
          icon: 'mdi-cash-fast',
          to: '/admin/dividend-backfill',
        },
        {
          title: 'investor quotes',
          subtitle: 'manage investor quotes displayed in the app',
          icon: 'mdi-format-quote-open',
          to: '/quotes',
        },
      ],
    };
  },
};
</script>
